console.log('🔍 Predictive Search Tabs Script Loaded');

function setActivePredictiveSearchTab(predictiveSearch, tabName) {

  const tabs = predictiveSearch.querySelectorAll('.predictive-search__tab');
  const panels = predictiveSearch.querySelectorAll('.predictive-search__result-group[data-tab-panel]');

  tabs.forEach((tab) => {
    const isActive = tab.dataset.tab === tabName;
    tab.classList.toggle('is-active', isActive);
    if (isActive) {
    }
  });

  panels.forEach((panel) => {
    const isActive = panel.dataset.tabPanel === tabName;
    panel.classList.toggle('is-active', isActive);

  });
}

function activateFirstAvailablePredictiveSearchTab(predictiveSearch) {
  console.log('🔎 Finding first available tab...');


  const tabs = Array.from(predictiveSearch.querySelectorAll('.predictive-search__tab'));

  for (const tab of tabs) {
    const panel = predictiveSearch.querySelector(
      `.predictive-search__result-group[data-tab-panel="${tab.dataset.tab}"]`
    );


    const hasResults = panel.querySelector('.predictive-search__list-item');

    if (hasResults) {
      setActivePredictiveSearchTab(predictiveSearch, tab.dataset.tab);
      return;
    }
  }

}

document.addEventListener('click', function (event) {
  const tab = event.target.closest('.predictive-search__tab');
  if (!tab) return;

  const predictiveSearch = tab.closest('.predictive-search');

  setActivePredictiveSearchTab(predictiveSearch, tab.dataset.tab);
});

const mobilePredictiveResults = document.getElementById('MobileHeaderPredictiveResults');

if (mobilePredictiveResults) {

  const observer = new MutationObserver((mutations) => {

    const hasTabs = mobilePredictiveResults.querySelector('.predictive-search__tab');
    if (hasTabs) {
      activateFirstAvailablePredictiveSearchTab(mobilePredictiveResults);
    }
  });

  observer.observe(mobilePredictiveResults, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('click', function (event) {
  const tab = event.target.closest('.predictive-search__tab');
  if (!tab) return;

  event.preventDefault();

  const predictiveSearch = tab.closest('.predictive-search');


  setActivePredictiveSearchTab(predictiveSearch, tab.dataset.tab);
});